import z from 'zod';

export const OrganizationOwnerSchema = z.object({
  createdAt: z.string(),
  email: z.email(),
  fullName: z.string(),
  id: z.string(),
  lastLogin: z.string().nullable(),
  updatedAt: z.string(),
});

export const OrganizationSchema = z.object({
  id: z.string(),
  address: z.string(),
  createdAt: z.string(),
  name: z.string(),
  ownerId: z.string(),
  siteUrl: z.string().nullable(),
  updatedAt: z.string(),
  owner: OrganizationOwnerSchema.nullable(),
  isDemo: z.boolean().optional(),
  hideCompSetToggle: z.boolean().optional(),
  staffSource: z.enum(['ALIS', 'SLING']).optional(),
});
